import React from "react";
import styles from "./ProfileDetailPage.module.css";

export default function AboutMe({ aboutMe }) {
  if (!aboutMe) return null;

  return (
    <>
      <div className={styles.sectionHeader}>
        <hr className={styles.sectionLine} />
        <span className={styles.sectionTitle}>About Me</span>
        <hr className={styles.sectionLine} />
      </div>

      <div className={styles.aboutMe}>
        <p>
          {aboutMe.split("\n").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
      </div>
    </>
  );
}
